import React from "react";
import "./AdditionalPrincipalmsg.css";

function AdditionalPrincipalmsg() {
  return (
    <div id="full-message" className="additional-content-section">
      <div className="container">
        <h2 className="section-heading text-center">
          Our Vision and Commitment
        </h2>

        <p>
          Physiotherapy is essentially one of the healing sciences which pertain
          to the assessment of Musculoskeletal and Neurological disorders of
          function including pain and those of psychosomatic origin. It also
          deals with treatment by natural sources, based on movement, manual
          therapy and other physical agents to relieve pain, promote healing,
          prevent or ameliorate deformity, improve function, body health,
          stimulate or habilitate development in a child or rehabilitate those
          impaired by disease or trauma. The responsibilities of Physiotherapist
          therefore, revolves around the Philosophy described above i.e., aiming
          to prevent/cure secondary physical, psychological and social trauma in
          patients referred to him, through his advice, education and supportive
          counselling towards good management., by the virtue of his
          qualification. Physiotherapist acquires such a vast knowledge,
          experience and skill that in the medical profession he is legally and
          ethically responsible for planning, conducting and evaluating
          physiotherapy program for persons or patients. He is responsible for
          carrying out the Physiotherapy Treatment Program or selective part of
          it. He is also responsible to instruct the patients or persons and
          their families regarding the Physiotherapy Treatment Program and
          supervise “Physiotherapy Aids, students and other health workers”.
          Physiotherapy is required in Clinics, Industries and Games. Work of a
          Physiotherapist includes assessment and evaluation of the patients,
          prevention of Physical disabilities, deformities, to minimize the
          complications already occurred or at least stop them at the level at
          which it was received and rehabilitate. In hospital, planning the
          program of physiotherapy, the Physiotherapist reviews the medical
          record, evaluates the patients and identifies the patients‟ problems.
          A Physiotherapist must also keep in mind the views of other members of
          medical team. <br />
          <strong>
            Ahmad Mahmood Makhdoom <br /> Managing Director
          </strong>
        </p>

        <p>
          We continually strive to update our curriculum, integrate modern
          teaching methodologies, and provide state-of-the-art facilities to
          ensure that our graduates are well-equipped to meet the challenges of
          the rapidly evolving healthcare landscape. Our faculty comprises
          highly qualified and experienced professionals who are committed to
          mentorship and academic excellence.
        </p>

        <p>
          Sargodha Institute of health Sciences has laid the foundation of
          innovative learning and respectable career for the students who
          challenge traditional modernity. A physiotherapist is an indispensable
          constituent of health faculty in almost every hospital in the
          developed Countries. Public and private hospitals in Pakistan are
          either creating or increasing the seats for physiotherapists to
          provide comprehensive health services to the patients. SIHS is
          enlightening the youngsters about the rising scope of various health
          profession in our country. Five year program of Doctor of
          Physiotherapy is a vivid example of flourishing demand for
          specialization in the above mentioned field. Similarly we are also
          taking an initiative to start multiple other programmes related t
          Allied Health Sciences. Our faculty is noted for its educative
          brilliance and professional commitment. As the program director of
          Department, I ensure the students that SIHS will prove to be a source
          of their elation. We have sowed the seed of erudition and our students
          will nurture the tree to distribute its therapeutic fruit among all.{" "}
          <br />
          <strong>
            Dr. Hassan Makhdoom <br />
            Director/Chairman Board of Studies
          </strong>
        </p>

        <p>
          Thank you for considering Sargodha Institute Of Health Sciences as
          your partner in education. We look forward to welcoming you to our
          vibrant community.
        </p>

        <p className="principal-signature">
          Ahmad Mahmood Makhdoom <br />
          Managing Director
        </p>
      </div>
    </div>
  );
}

export default AdditionalPrincipalmsg;
